import api from '@/utils/api'
import { buildListQuery } from '@/utils/listQuery'

export default {
    getTeamApplications(page, size) {
        let range = '?range=' + encodeURIComponent(`[${page - 1},${size}]`)
        return api.get(`team-applications` + (page ? range : ''))
    },

    getFilteredTeamApplications(filter, page, size, sort) {
        return api.get(`team-applications` + buildListQuery({ filter, page, size, sort }))
    },

    getTeamApplication(id) {
        return api.get(`team-applications/${id}`)
    },

    // creates the team and its players and marks the application accepted, in one backend transaction
    approveTeamApplication(id, data) {
        return api.post(`team-applications/${id}/approve`, data)
    },

    rejectTeamApplication(id) {
        // the endpoint takes the enum as a JSON string body
        return api.post(`team-applications/${id}/status`, JSON.stringify('rejected'))
    },

    deleteTeamApplication(id) {
        return api.delete(`team-applications/${id}`)
    }
}
